/**
 * Loading Bridge
 *
 * Bridges the gap between module-level code (Axios interceptors, Router events)
 * and the React context (LoadingProvider).
 *
 * The LoadingProvider registers its show/hide functions here on mount,
 * and Axios interceptors + Router events call the bridge functions.
 */

type LoaderFunction = () => void;

let showLoaderFn: LoaderFunction | null = null;
let hideLoaderFn: LoaderFunction | null = null;

/**
 * Called by LoadingProvider on mount to register context functions.
 */
export const registerLoadingFunctions = (
  show: LoaderFunction,
  hide: LoaderFunction
): void => {
  showLoaderFn = show;
  hideLoaderFn = hide;
};

/**
 * Called by LoadingProvider on unmount to clean up.
 */
export const unregisterLoadingFunctions = (): void => {
  showLoaderFn = null;
  hideLoaderFn = null;
};

/**
 * Safe wrapper — calls showLoader if the provider is registered.
 */
export const bridgeShowLoader = (): void => {
  if (showLoaderFn) {
    showLoaderFn();
  }
};

/**
 * Safe wrapper — calls hideLoader if the provider is registered.
 */
export const bridgeHideLoader = (): void => {
  if (hideLoaderFn) {
    hideLoaderFn();
  }
};
